import { useFirestore } from '../../../firebase/useFirestore'
import usePermissions from '../../../hooks/usePermissions'
import HuisstijlSettings from '../../settings/HuisstijlSettings.jsx'

/**
 * Huisstijl tab: hetzelfde gedeelde logo/kleuren-blok als Instellingen →
 * Algemeen (één component, één schrijfpad). Eén keer instellen, geldt voor
 * alle kanalen en uitingen. See docs/features/impact-in-beeld-hub.md.
 */
const HuisstijlTab = () => {

    const compagny = useFirestore('CompagnyMeta')
    const { has, ready } = usePermissions()
    const canEdit = !ready || has('settings.edit')

    return (
        <div className='impact-in-beeld-tab'>
            <h2>Huisstijl</h2>
            <p className='impact-in-beeld-tab-intro'>
                Stel je logo en kleuren één keer in — ze gelden voor al je uitingen en kanalen.
            </p>
            {compagny && compagny.map(comp => (
                <HuisstijlSettings key={comp.ID} comp={comp} canEdit={canEdit} />
            ))}
        </div>
    )
}

export default HuisstijlTab
